import React from "react"
import {
  Layout,
  Typography,
} from "antd"
import {
  PhoneOutlined,
} from "@ant-design/icons"
import { useNavigate } from "react-router-dom"
import ROUTER from "src/router"
import { COMPANY, HOTLINE } from "src/constants/constants"

const { Header, Content, Footer } = Layout
const { Text } = Typography

const MainLayout = ({ children }) => {
  const navigate = useNavigate()

  return (
    <Layout
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        // Fix viewport height động trên iOS Safari
        // minHeight: "-webkit-fill-available",
      }}
    >
      {/* Header - dùng fixed thay vì sticky để ổn định trên Safari iOS */}
      <Header
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: 64,           // cố định chiều cao → tránh nhảy trên iOS
          background: "linear-gradient(90deg, #87CEFA 0%, #00BFFF 100%)",
          padding: "0 16px",
          zIndex: 1000,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            cursor: "pointer",
          }}
          onClick={() => navigate(ROUTER.MAIN_PAGE)}
        >
          <Text
            strong
            style={{
              fontSize: 17,
              color: "#004e98",
              lineHeight: "22px",
            }}
          >
            BẢO HIỂM TRÁCH NHIỆM DÂN SỰ
          </Text>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: 13,
              fontWeight: 600,
              color: "#004e98",
              marginTop: 2,
            }}
          >
            <PhoneOutlined style={{ marginRight: 6 }} />
            Hotline: <strong style={{ marginLeft: 4 }}>{HOTLINE}</strong>
          </div>
        </div>

        {/* Có thể thêm nút menu hoặc login ở đây nếu cần */}
      </Header>

      {/* Content - bù lại chiều cao header + scroll mượt */}
      <Content
        style={{
          marginTop: 64,                    // bằng height của Header fixed
          flex: 1,
          overflowY: "auto",                // hoặc "scroll" cũng được
          WebkitOverflowScrolling: "touch", // BẮT BUỘC cho Safari iOS để scroll mượt + không lock
          // Ẩn scrollbar đẹp cross-browser
          scrollbarWidth: "none",           // Firefox
          msOverflowStyle: "none",          // IE/Edge cũ
          "&::-webkit-scrollbar": {         // Chrome/Safari/Edge
            display: "none",
          },
        }}
      >
        {children}
      </Content>

      {/* Footer */}
      <Footer
        style={{
          textAlign: "center",
          fontSize: 12,
          color: "#555",
          background: "#f8f9fa",
          padding: "12px 16px",
          borderTop: "1px solid #e8e8e8",
          flexShrink: 0,
        }}
      >
        © 2026 {COMPANY} <br />
        Hotline: <strong>{HOTLINE}</strong> <br />
        Email: lienhe@baohiemtrachnhiemdansu.vn
      </Footer>

      {/* Fix viewport height cho iOS Safari */}
      <style jsx global>{`
        html {
          height: -webkit-fill-available;
        }
        body {
          min-height: 100vh;
          min-height: -webkit-fill-available;
        }
        /* Đảm bảo không có margin/padding thừa */
        * {
          box-sizing: border-box;
        }
      `}</style>
    </Layout>
  )
}

export default MainLayout